import React, { useState } from "react";
import Layout from "../form-layout";
import { FORM_B_CURRENT_MEDICATIONS } from "../../data/eligibility-rules";

// Form B Q1 — "Which medication are you currently using?" Options match the doc
// exactly (label text and order) — see FORM_B_CURRENT_MEDICATIONS.
// Routing: picking "Other" skips the dose question (Q2) and goes straight to Q3.
export default function CurrentMedicationDose({ formData, setFormData, onBack, goToStep }) {
  const [selected, setSelected] = useState(formData.currentGlp1Med || "");
  const [otherText, setOtherText] = useState(formData.currentGlp1MedOther || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected) return;
    if (selected === "other" && !otherText.trim()) return;

    setFormData((prev) => ({
      ...prev,
      currentGlp1Med: selected,
      currentGlp1MedOther: otherText,
    }));
    localStorage.setItem("currentGlp1Med", selected);
    localStorage.setItem("currentGlp1MedOther", otherText);

    goToStep(selected === "other" ? "b3" : "b2");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        Which medication are you currently using?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {FORM_B_CURRENT_MEDICATIONS.map((med) => (
          <label key={med.key} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="currentGlp1Med"
              checked={selected === med.key}
              onChange={() => setSelected(med.key)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{med.label}</span>
          </label>
        ))}

        {selected === "other" && (
          <input
            type="text"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            placeholder="Please specify"
            className="border-2 border-sky-400 rounded-md p-2 text-sm w-full"
          />
        )}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!selected || (selected === "other" && !otherText.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !selected || (selected === "other" && !otherText.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
